import { rdRequests } from "../httpRequest";

const webCheckInApiRequest = {
    validateCheckInReservation: (requestData: any) => rdRequests.get(`webaccessfacility/ValidateCheckInReservation?confirmationNumber=${requestData.confirmationNumber}&lastName=${requestData.lastName}&placeId=${requestData.placeId}`)
}

export default webCheckInApiRequest;